/* eslint-disable */
import _ from 'underscore';
import $ from 'jquery';
import Template from '@bingads-webui-static-legacy/shared/template/popup.pug';
import uiBlocker from '@bingads-webui-component-legacy/uiblocker/service/uiBlocker';
var container;
var popupContentContainer;
var containerSelector = '.popup-container';
var contentSelector = '.popup-content';
var dialogSelector = '.popup-dialog';
var defaultHeight = 400;
var blocked = false;
var render = function (renderHtml, height) {
  preparePopupContainer();
  if (popupContentContainer && popupContentContainer.length > 0) {
    popupContentContainer.html(renderHtml);
    if (popupContentContainer.length > 0) {
      _.each(popupContentContainer.children(), function (child) {
        $(child).addClass('center-block');
      });
    }
  }
  if (!_.isUndefined(height) && _.isNumber(height)) {
    container.find(dialogSelector).css({
      'height': height + 'px'
    });
  } else {
    container.find(dialogSelector).css({
      'height': defaultHeight + 'px'
    });
  }
  show();
};
var drag_start = function (event) {
  event.originalEvent.dataTransfer.setData('text', event.clientX + ',' + event.clientY);
};
var drop = function (event, draggableItem) {
  var eventStart = event.originalEvent.dataTransfer.getData('text').split(',');
  var moveOnYAxis = event.clientY - parseInt(eventStart[1], 10);
  var moveOnXAxis = event.clientX - parseInt(eventStart[0], 10);
  var originOffset = draggableItem.offset();
  draggableItem.offset({
    top: originOffset.top + moveOnYAxis,
    left: originOffset.left + moveOnXAxis
  });
  event.preventDefault();
  return false;
};
var drag_over = function (event) {
  event.preventDefault();
  return false;
};
var draggable = function (draggableItem, draggableContainer) {
  draggableItem.on('dragstart', drag_start);
  draggableContainer.on('dragover', drag_over);
  draggableContainer.on('drop', function (event) {
    drop(event, $(draggableItem[0]));
  });
};
var bindDraggable = _.once(function (container) {
  draggable(container, $('body'));
});
var preparePopupContainer = function () {
  container = $(containerSelector);
  popupContentContainer = container.length > 0 ? container.find(contentSelector) : null;
  if (container.length === 0 || !popupContentContainer || popupContentContainer.length === 0) {
    container.remove();
    var oldBlocker = $('.blocker-panel');
    if (oldBlocker.length == 1) {
      $(Template()).insertBefore(oldBlocker);
    } else {
      $('body').append(Template());
    }
    container = $(containerSelector);
    popupContentContainer = container.find(contentSelector);
  } else {
    popupContentContainer.empty();
  }
  $(document).unbind('click.popup');
  $(document).bind('click.popup', closePopupByClick);
  bindDraggable(popupContentContainer);
};
var show = function () {
  if (!_.isUndefined(container) && container != null) {
    container.removeClass('fade');
    container.addClass('show');
  }
};
var hide = function () {
  if (!_.isUndefined(container) && container !== null) {
    container.removeClass('show');
    container.addClass('fade');
    if (blocked) {
      uiBlocker.unblock(container, 'popupBlocker');
    }
  }
};
var resizeBlockingImg = function () {
  $.advertiser.showLoadingPanel();
  $('.blocker-panel').css({
    'left': 0,
    'top': '0 !important'
  });
};
var block = function () {
  if (!_.isUndefined(container) && container !== null) {
    uiBlocker.block(container, 'popupBlocker');
    blocked = true;
  }
};
var closePopupByClick = function (e) {
  const $target = $(e.target);
  if ($target.closest('.popup-content').length === 1 || $target.attr('data-role') === 'droptarget') {
    return;
  }
  closePopup();
};
var closePopup = function (e) {
  hide();
  $(document).unbind('click.popup');
};
export default {
  render: render,
  close: closePopup,
  show: show,
  block: block,
  resizeBlockingImg: resizeBlockingImg
};

